import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { t } from '../hooks/useT';

interface ResultState {
  won: boolean;
  score: number;
  dezoomsUsed: number;
  durationSec: number;
  shareText: string | null;
  puzzleNumber: number;
}

export function ResultPage() {
  const location = useLocation();
  const state = location.state as ResultState | null;
  const [copied, setCopied] = useState(false);

  if (!state) {
    return (
      <main className="page result">
        <p>Pas de résultat.</p>
        <Link to="/play">Rejouer</Link>
      </main>
    );
  }

  const handleShare = async () => {
    if (!state.shareText) return;
    try {
      await navigator.clipboard.writeText(state.shareText);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* fallback silent */
    }
  };

  const mins = Math.floor(state.durationSec / 60);
  const secs = state.durationSec % 60;

  return (
    <main className="page result">
      <h1>{state.won ? t('result.win') : t('result.fail')}</h1>
      {state.won && <p className="score">{state.score} pts</p>}
      <ul className="stats">
        <li>{state.dezoomsUsed} dézooms</li>
        <li>{mins}:{secs.toString().padStart(2, '0')}</li>
        <li>#{state.puzzleNumber}</li>
      </ul>
      {state.shareText && (
        <button type="button" className="btn primary" onClick={handleShare}>
          {copied ? t('result.copied') : t('result.share')}
        </button>
      )}
      <pre className="share-preview">{state.shareText}</pre>
      <nav className="result-nav">
        <Link to="/leaderboard">Classement</Link>
        <Link to="/">Accueil</Link>
      </nav>
    </main>
  );
}
